import { types } from '../../../constants/ActionTypes'

const initialState = {
  records: [],
  isFetching: false,
  ready: false,
}

const eventListCard = (state = initialState, action) => {
  switch (action.type) {
    case types.eventListCard.REQUEST_SELECT_EVENT:
      return { ...state, isFetching: true }
    case types.eventListCard.RESPONSE_SELECT_EVENT:
      if (action.response.result === false) {
        return { ...state, isFetching: false, ready: true }
      }
      return { ...state, records: action.response.records, isFetching: false, ready: true }
    default:
      return state
  }
}

export default eventListCard


// WEBPACK FOOTER //
// ./src/reducers/Common/Event/EventListCard.js